'use client'
import React from 'react'
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Image from "next/image";
import Link from 'next/link';
import leftarrow from '@/public/home-images/left-arrow.png';
import rightarrow from '@/public/home-images/right-arrow.png';
import CustomLink from '../common/custom-link';

function BlogSlider(props) {
    var settings = {
        dots: false,
        infinite: false,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        initialSlide: 0,
        responsive: [
        {
            breakpoint: 1024,
            settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            infinite: true,
            dots: true
            }
        },
        {
            breakpoint: 600,
            settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            initialSlide: 2
            }
        },
        {
            breakpoint: 480,
            settings: {
            slidesToShow: 1.25,
            slidesToScroll: 1,
            dots: false
            }
        }
        ]
    };
    const handleNext = () => {
        slider.slickNext();
    };

    const handlePrevious = () => {
        slider.slickPrev();
    };

    let slider;
    
    function formatDate(inputDate) {
        if (!inputDate) {
          // Handle the case where inputDate is null or undefined
          return null;
        }
      
        const parts = inputDate.split('-');
        if (parts.length !== 3) {
          // Invalid input format
          return "Invalid Date";
        }
      
        const year = parts[0];
        const month = parts[1];
        const day = parts[2];
      
        const outputDate = `${day}-${month}-${year}`;
        return outputDate;
      }
  
    const { data, currentBlogTitle } = props;

    // Filter out the current blog from related blogs
    const filteredData = data.data?.filter((blog) => blog.attributes.blogTitle !== currentBlogTitle);

    return (
        <div className='custom-container lg:mb-20 mb-10'>
            <h2 className='text-primaryBlue font-bold text-4xl text-center mb-10'>{props.blogInternal.heading}</h2>
            <div className='relative'>
                <Slider {...settings} ref={(c) => (slider = c)}>
                {
                    filteredData?.map((e, i) => (
                    <CustomLink lang={props.lang} href={`/blogs-articles/${e?.attributes.blogTag.replaceAll(/\s/g, '-')}`} key={i} className='blogspage-link'>
                        <div className='group relative xl:h-96 h-80 border-solid border rounded-3xl overflow-hidden border-gray-300 mx-2.5'>
                            <div>
                                <Image src={`${process.env.NEXT_PUBLIC_BE_URL}${e?.attributes?.blogImage?.data?.attributes?.url}`} alt={e?.attributes?.blogImage?.data?.attributes?.alternativeText || 'Apex Hospitals Blogs'} title={e?.attributes?.blogImage?.data?.attributes?.alternativeText || 'Apex Hospitals Blogs'} className='block w-full md:h-[220px] object-cover' width={380} height={220} />
                            </div>
                            <div className='absolute xl:top-[218px] top-[166px] h-full left-0 right-0 bg-white group-hover:top-0 transition-all ease-in-out duration-500'>
                                <div className='xl:h-[105px] lg:h-[81px] h-[80px] px-4 pt-4 group-hover:h-auto transition-all ease-in-out duration-500'>
                                    <h3 className='header-sub font-bold text-gray-600 text-ellipsis line-clamp-3'>{e.attributes.blogTitle}</h3>
                                </div>
                                <div className='p-4 xl:mt-3 lg:mt-5 mt-7 group-hover:mt-1 group-hover:pt-1  transition-all ease-in-out duration-500'>
                                    <h5 className='text-primaryGreyText text-base pb-3 group-hover:pb-0 transition-all ease-in-out duration-500'>{formatDate(e.attributes.blogDate)}</h5>
                                    <p className='text-primaryGreyText text-sm pr-2.5 pt-7 group-hover:pt-1 transition-all ease-in-out duration-500 h-44 overflow-y-scroll'>{e.attributes.blogShortDescription}</p>
                                </div>
                            </div>
                        </div>
                    </CustomLink>
                    ))
                }
                </Slider>

                <div className='flex justify-between'>
                    <button className="lg:block hidden rounded-full border border-primaryGrey py-3 px-4 absolute -translate-y-1/2 -left-12 top-2/4" onClick={handlePrevious}>
                        <Image src={leftarrow} alt="left arrow" title="left arrow" height={24} width={12} />
                    </button>
                    <button className="lg:block hidden rounded-full border border-primaryGrey py-3 px-4 absolute -right-12 -translate-y-1/2 top-2/4" onClick={handleNext}>
                        <Image src={rightarrow} alt="left arrow" title="left arrow" height={24} width={12} />
                    </button>
                </div>
            </div>

        </div>
    )
}

export default BlogSlider;